import type { AppRegion, IAppRegionInfo } from "@core-types/region.enum";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Button, Image } from "@mantine/core";
import { LOL_GRADIENT } from "./LolRegionSelectorBanner";

interface IRegionButtonProps {
  region: IAppRegionInfo;
  isSelected: boolean;
  onClick?: (region: AppRegion) => void;
  gradientVariant?: MantineGradientVariant;
  icon?: string;
}

export interface MantineGradientVariant {
  from: string;
  to: string;
}

const RegionButton: React.FC<IRegionButtonProps> = ({
  region,
  isSelected,
  onClick,
  gradientVariant,
  icon,
}) => {
  const { t } = useAppTranslation("components.regionSelector.images");

  return (
    <Button
      onClick={() => onClick?.(region.code)}
      className="rounded-xl border-[#424242] border-[0.5px] border-solid bg-[#23252A] font-bold font-secret text-white hover:bg-[#2C2E33] hover:text-white"
      variant={isSelected ? "gradient" : "filled"}
      gradient={gradientVariant ?? LOL_GRADIENT}
      leftSection={
        icon && (
          <Image src={icon} alt={t(`${region.code}.alt`)} className="size-6" />
        )
      }
    >
      {region.codeLabel}
    </Button>
  );
};

export default RegionButton;
